<template>
  <v-card elevation="4" :color="color">
    <!-- Name -->
    <v-card-title>
      {{ application.FirstName }} {{ application.Surname }}
    </v-card-title>
    <!-- Email -->
    <v-card-text v-if="!this.application.rejected">
      <v-label>Email: </v-label>
      <a target="_blank" :href="`mailto:${application.Email}`">
        {{ application.Email }}
      </a>
    </v-card-text>
    <!-- ABOUT -->
    <v-card-text v-if="application.About && !this.application.rejected">
      <v-label>About</v-label>
      <div class="text--primary">
        {{ application.About }}
      </div>
    </v-card-text>
    <!-- FILES -->
    <v-card-text v-if="!this.application.rejected">
      <v-label>Files</v-label>
      <div>
        <v-chip
          color="primary"
          class="mr-2 mb-2"
          icon
          v-for="file in application.files"
          :key="file.name"
          target="_blank"
          :href="file.download"
        >
          <v-icon left>mdi-label</v-icon>
          <div v-if="file.name.length > 30">
            {{ file.name.substring(0, 30) }}...
          </div>
          <div v-else>{{ file.name.substring(0, 30) }}</div>
        </v-chip>
      </div>
    </v-card-text>
    <!-- Buttons -->
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        icon
        top
        right
        absolute
        @click="fav"
        :color="application.fav ? '#FFD600' : ''"
      >
        <v-icon>mdi-star</v-icon>
      </v-btn>
      <v-btn
        v-if="application.rejected"
        class="mr-10 ma-1"
        outlined
        absolute
        top
        right
        rounded
        small
        :ripple="false"
      >
        Rejected
      </v-btn>
      <v-btn
        v-if="application.nextStep"
        class="mr-10 ma-1"
        outlined
        absolute
        top
        right
        rounded
        small
        :ripple="false"
      >
        Next Step
      </v-btn>

      <v-btn
        v-if="!application.nextStep && !application.rejected"
        @click="reject"
        color="error"
      >
        Reject
      </v-btn>
      <v-btn
        v-if="!application.nextStep && !application.rejected"
        @click="nextStep"
        color="success"
      >
        Next step
      </v-btn>
      <v-btn v-else @click="undo">Undo</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  fiery: true,
  props: ["application"],
  methods: {
    fav: function() {
      this.application.fav = !this.application.fav;
      this.$fiery.sync(this.application);
    },
    reject: function() {
      this.application.rejected = true;
      this.$fiery.sync(this.application);
    },
    nextStep: function() {
      this.application.nextStep = true;
      this.$fiery.sync(this.application);
    },
    undo: function() {
      this.application.nextStep = false;
      this.application.rejected = false;
      this.$fiery.sync(this.application);
    }
  },
  computed: {
    color: function() {
      if (this.application.nextStep) {
        return "#66BB6A";
      } else if (this.application.rejected) {
        return "#FF7043";
      } else {
        return "";
      }
    }
  }
};
</script>